export const config = {
  apiUrl: process.env.NEXT_PUBLIC_API_URL,
  skin: process.env.NEXT_PUBLIC_APP_SKIN,
  trademarkApiUrl: process.env.NEXT_PUBLIC_TRADEMARK_API_URL,
  email: process.env.NEXT_PUBLIC_EMAIL_APP,
  membership: process.env.NEXT_PUBLIC_MEMBERSHIP_LINK,
  phone: process.env.NEXT_PUBLIC_PHONE_APP,
  phoneSms: process.env.NEXT_PUBLIC_APP_PHONE_SMS,
  basePath: process.env.NEXT_PUBLIC_BASE_PATH,
  gtmId: process.env.NEXT_PUBLIC_APP_GTM,
  gaId: process.env.NEXT_PUBLIC_APP_GA,
};
